import { ChangeEvent, Component } from "react";
import Tooltip from "react-tooltip-lite";
import { AutomaticOrdering, InventoryItem } from "../../Generated/graphql";
import { Icon } from "../Icon/Icon";
import { ListItem } from "../ListItem/ListItem";
import { ModalButton } from "../ModalButton/ModalButton";
import { NumberInput } from "../NumberInput/NumberInput";
import { PrintBarcode } from "../PrintBarcode/PrintBarcode";
import { ProgressBar } from "../ProgressBar/ProgressBar";
import { TextInput } from "../TextInput/TextInput";
import "./AddItemDetails.css";

interface IAddItemDetailsProps {
  product: Partial<InventoryItem>;
  resetToSearch: () => void;
  setValues: (e: ChangeEvent<HTMLInputElement>) => void;
  onTextValueChangeHandler: (e: ChangeEvent<HTMLInputElement>) => void;
  addOneFunction: (name: string, value: number) => void;
  minusOneFunction: (name: string, value: number) => void;
  toggleAutoOrdering: () => void;
  isAdded: boolean;
}

interface IAddItemDetailsState {
  isAdded: boolean;
}

export class AddItemDetails extends Component<
  IAddItemDetailsProps,
  IAddItemDetailsState
> {
  constructor(props: IAddItemDetailsProps) {
    super(props);

    this.state = {
      isAdded: false,
    };
  }
  componentDidUpdate = (props: IAddItemDetailsProps) => {
    if (this.state.isAdded !== props.isAdded && this.state.isAdded === false) {
      this.setState({ isAdded: true });
    }
  };

  render() {
    const {
      product,
      addOneFunction,
      minusOneFunction,
      onTextValueChangeHandler,
      resetToSearch,
      toggleAutoOrdering,
    } = this.props;
    const productStatus = product.status;
    const unit =
      product.amountPerUnit && product.amountPerUnit > 1
        ? "ks."
        : "stk." ;

    
    const discontinuedStatuses = [90]
    const permanentlyDiscontinuedStatuses = [99]
    const discontinuedAtZeroStatuses = [85]
    const procuredStatuses = [35]


    return (
      <div className="AddItemDetails">
        <div className="AddItemDetails__discontinued">
          {discontinuedAtZeroStatuses.includes(productStatus as number) && (
            <div className="EditItem__discontinued">
              <div className="EditItem__discontinued__tag">
                <div className="EditItem__discontinued__tag-text">Udgår ved lager 0</div>
              </div>
              <Tooltip
                className="EditItem__discontinued--tooltip"
                hoverDelay={100}
                direction="below"
                content={
                  <div className="EditItem__discontinued--tooltip-content">
                    Varen udgår hos leverandøren når lageret når 0 og kan ikke bestilles.
                  </div>
                }
              >
                <Icon name="iconHelp" width={18} height={18} />
              </Tooltip>
            </div>
          )}
        </div>
        <div className="AddItemDetails__discontinued">
          {(discontinuedStatuses.includes(productStatus as number) || !productStatus)  && (
            <div className="EditItem__discontinued">
              <div className="EditItem__discontinued__tag">
                <div className="EditItem__discontinued__tag-text">Udgået</div>
              </div>
              <Tooltip
                className="EditItem__discontinued--tooltip"
                hoverDelay={100}
                direction="below"
                content={
                  <div className="EditItem__discontinued--tooltip-content">
                    Varen er udgået hos leverandøren og kan ikke bestilles.
                  </div>
                }
              >
                <Icon name="iconHelp" width={18} height={18} />
              </Tooltip>
            </div>
          )}
        </div>
        <div className="AddItemDetails__discontinued">
          {permanentlyDiscontinuedStatuses.includes(productStatus as number) && (
            <div className="EditItem__discontinued">
              <div className="EditItem__discontinued__tag">
                <div className="EditItem__discontinued__tag-text">Permanent udgået</div>
              </div>
              <Tooltip
                className="EditItem__discontinued--tooltip"
                hoverDelay={100}
                direction="below"
                content={
                  <div className="EditItem__discontinued--tooltip-content">
                    Varen er permanent udgået hos leverandøren og kan ikke bestilles.
                  </div>
                }
              >
                <Icon name="iconHelp" width={18} height={18} />
              </Tooltip>
            </div>
          )}
        </div>
        {/* <div className="AddItemDetails__discontinued">
          {discontinuedAtZeroStatuses.includes(productStatus as number)  && (
            <div className="EditItem__discontinued">
              <div className="EditItem__discontinued__tag">
                <div className="EditItem__discontinued__tag-text">Udgår v. 0</div>
              </div>
              <Tooltip
                className="EditItem__discontinued--tooltip"
                hoverDelay={100}
                direction="below"
                content={
                  <div className="EditItem__discontinued--tooltip-content">
                    Varen er udgår hos leverandøren ved 0.
                  </div>
                }
              >
                <Icon name="iconHelp" width={18} height={18} />
              </Tooltip>
            </div>
          )}
        </div> */}
        <div className="AddItemDetails__discontinued">
          {procuredStatuses.includes(productStatus as number)  && (
            <div className="EditItem__discontinued">
              <div className="EditItem__discontinued__tag">
                <div className="EditItem__discontinued__tag-text">Skaffevare</div>
              </div>
              <Tooltip
                className="EditItem__discontinued--tooltip"
                hoverDelay={100}
                direction="below"
                content={
                  <div className="EditItem__discontinued--tooltip-content">
                    Dette er en skaffeavare og kan ikke automatisk genbestilles.
                  </div>
                }
              >
                <Icon name="iconHelp" width={18} height={18} />
              </Tooltip>
            </div>
          )}
        </div>
        <div className="AddItemDetails__edit" onClick={() => resetToSearch()}>
          <Icon name="editBtn" width={25} />
          <div className="AddItemDetails__edit-text">Fortryd</div>
        </div>
        <div className="AddItemDetails__atrribute AddItemDetails__name">
          <ListItem title="Navn">
            <TextInput
              value={product.name}
              name="name"
              change={(e: ChangeEvent<HTMLInputElement>) =>
                onTextValueChangeHandler(e)
              }
              textAlign="right"
              readOnly
            />
          </ListItem>
        </div>
        <div className="AddItemDetails__atrribute">
          <ListItem title="Varenummer">
            <TextInput
              value={product.productNumber}
              name="id"
              change={(e: ChangeEvent<HTMLInputElement>) =>
                onTextValueChangeHandler(e)
              }
              textAlign="right"
              readOnly
            />
          </ListItem>
        </div>
        <div className="AddItemDetails__atrribute">
          <ListItem title="Beskrivelse">
            <TextInput
              value={product.description}
              name="description"
              change={(e: ChangeEvent<HTMLInputElement>) =>
                onTextValueChangeHandler(e)
              }
              textAlign="right"
              readOnly
            />
          </ListItem>
        </div>
        {((product.dataSheetDetails && product.dataSheetDetails.length > 0) || (product.dataSheets && product.dataSheets.length > 0)) && (
          <div className="AddItemDetails__atrribute AddItemDetails__atrribute--datasheets">
            <ListItem title="Datablad">
              <div className="AddItemDetails__data-sheets-list">
                {product.dataSheetDetails && product.dataSheetDetails.length > 0 ? 
                  product.dataSheetDetails.map((ds: any, index: number) => (
                    <a
                      key={index}
                      href={ds.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="AddItemDetails__data-sheet-link"
                    >
                      {ds.description === 'TDS' ? 'Teknisk datablad' : 
                       ds.description === 'MSDS' ? 'Sikkerhedsdatablad' : 
                       ds.description || `Datablad ${index + 1}`}
                    </a>
                  )) :
                  product.dataSheets?.map((url: string, index: number) => (
                    <a
                      key={index}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="AddItemDetails__data-sheet-link"
                    >
                      Datablad {index + 1}
                    </a>
                  ))
                }
              </div>
            </ListItem>
          </div>
        )}
        {product.replacementProducts && product.replacementProducts.length > 0 && (
          <div className="AddItemDetails__atrribute AddItemDetails__atrribute--replacements">
            <ListItem title="Erstatningsprodukter">
              <div className="AddItemDetails__replacement-list">
                {product.replacementProducts.map((prodNo: string) => (
                  <span key={prodNo} className="AddItemDetails__replacement-link">
                    {prodNo}
                  </span>
                ))}
              </div>
            </ListItem>
          </div>
        )}
        <div className="AddItemDetails__atrribute">
          <ListItem title="Stregkode">
            <>
              <TextInput
                value={product.barcode ?? ""}
                name="barcode"
                change={(e: ChangeEvent<HTMLInputElement>) =>
                  onTextValueChangeHandler(e)
                }
                textAlign="right"
                readOnly
              />
              {product.barcode && (
                <div className="EditItem__print-barcode">
                  <PrintBarcode
                    barcode={product.barcode}
                    name={product.name!}
                    prodNo={product.productNumber!}
                    description={product.description!}
                  />
                </div>
              )}
            </>
          </ListItem>
        </div>
        <div className="AddItemDetails__atrribute">
          <ListItem title="Kategori">
            <TextInput
              value={product.category}
              name="category"
              change={(e: ChangeEvent<HTMLInputElement>) =>
                onTextValueChangeHandler(e)
              }
              textAlign="right"
              readOnly
            />
          </ListItem>
        </div>
        <div className="AddItemDetails__atrribute">
          <ListItem title="Aktuel Beholdning">
            <div className="AddItemDetails__currentStock">
              <div className="AddItemDetails__stock-bar">
                <ProgressBar
                  current={product.amount}
                  min={product.minimum}
                  max={product.maximum}
                />
              </div>
              <div className="AddItemDetails__numberInput">
                <NumberInput
                  value={product.amount!}
                  unit={unit}
                  name="inStock"
                  change={(e) => onTextValueChangeHandler(e)}
                  addOneFunction={() =>
                    addOneFunction("amount", product.amount!)
                  }
                  minusOneFunction={() =>
                    minusOneFunction("amount", product.amount!)
                  }
                />
              </div>
            </div>
          </ListItem>
        </div>
        <div className="AddItemDetails__atrribute">
          <ListItem title="Automatisk genbestilling">
            <div className="AddItemDetails__auto-reorder u-cursor-pointer">
              <ModalButton
                buttonStyle="toggleButton"
                iconName={
                  product.automaticOrderingState === AutomaticOrdering.Active
                    ? "autoOrderActive"
                    : "orderingDisabled"
                }
                labelStyle="toggleLabel"
                autoOrderState={product.automaticOrderingState}
                width={19}
                click={() => toggleAutoOrdering()}
              />
            </div>
          </ListItem>
        </div>
        <div className="AddItemDetails__atrribute">
          <ListItem title="Minimumsbeholdning">
            <div className="AddItemDetails__numberOnlyInput">
              <NumberInput
                value={product.minimum!}
                unit={unit}
                name="minimum"
                change={(e) => onTextValueChangeHandler(e)}
                addOneFunction={() =>
                  addOneFunction("minimum", product.minimum!)
                }
                minusOneFunction={() =>
                  minusOneFunction("minimum", product.minimum!)
                }
              />
            </div>
          </ListItem>
        </div>
        <div className="AddItemDetails__atrribute">
          <ListItem title="Ønsket beholdning">
            <div className="AddItemDetails__numberOnlyInput">
              <NumberInput
                value={product.maximum!}
                unit={unit}
                name="maximum"
                change={(e) => onTextValueChangeHandler(e)}
                addOneFunction={() =>
                  addOneFunction("maximum", product.maximum!)
                }
                minusOneFunction={() =>
                  minusOneFunction("maximum", product.maximum!)
                }
              />
            </div>
          </ListItem>
        </div>
      </div>
    );
  }
}
